<form nz-form #form="ngForm">
	<nz-form-item>
		<nz-form-control>
			<nz-input-group nzPrefixIcon="user">
				<input class="pl-2" type="text" nz-input name="userName" required [placeholder]="'user.username' | translate" [(ngModel)]="result.username" [disabled]="forceCurrentUser"/>
			</nz-input-group>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item>
		<nz-form-control>
			<nz-input-group nzPrefixIcon="lock">
				<input class="pl-2" type="password" nz-input name="password" required [placeholder]="'user.password' | translate" [(ngModel)]="result.password"/>
			</nz-input-group>
		</nz-form-control>
	</nz-form-item>
</form>
<div *nzModalFooter>
	<button nz-button nzType="default" (click)="cancel()">{{'actions.cancel' | translate}}</button>
	<button nz-button nzType="primary" [disabled]="form.invalid" (click)="confirm()">{{'login-dialog.login' | translate}}</button>
</div>